function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Cluster as olCluster } from 'ol/source';
import { filterFeaturesByAttribute, filterFeaturesByGeometry } from 'oskari-frontend/bundles/mapping/mapmodule/util/vectorfeatures/filter';
import { getFeatureAsGeojson } from 'oskari-frontend/bundles/mapping/mapmodule/util/vectorfeatures/jsonHelper';
import { getZoomLevelHelper } from 'oskari-frontend/bundles/mapping/mapmodule/util/scale';
import { SelectionHelper } from './SelectionHelper';
var LOADING_STATUS_VALUE = {
  COMPLETE: 'complete',
  LOADING: 'loading',
  ERROR: 'error'
};
export { LOADING_STATUS_VALUE };
export var AbstractLayerHandler = /*#__PURE__*/function () {
  function AbstractLayerHandler(layerPlugin) {
    _classCallCheck(this, AbstractLayerHandler);
    this.plugin = layerPlugin;
    this.layerIds = [];
    this.throttledUpdates = new Map();
    this._log = Oskari.log('Oskari.mapping.mapmodule.AbstractLayerHandler');
    this.sb = Oskari.getSandbox();
    this.loadingTimers = new Map();
    this.timerDelayInMillis = 60000;
    this.selectionHelper = new SelectionHelper(layerPlugin);
  }

  /**
   * @method addMapLayerToMap Adds wfs layer to map
   * Implementing classes should call this function by super.addMapLayerToMap()
   * @param {Oskari.mapframework.bundle.mapwfs2.domain.WFSLayer} layer
   * @param {Boolean} keepLayerOnTop
   * @param {Boolean} isBaseMap
   */
  return _createClass(AbstractLayerHandler, [{
    key: "addMapLayerToMap",
    value: function addMapLayerToMap(layer, keepLayerOnTop, isBaseMap) {
      this.layerIds.push(layer.getId());
    }

    /**
     * @method createEventHandlers Creates layer handler specific event handlers
     */
  }, {
    key: "createEventHandlers",
    value: function createEventHandlers() {
      var _this = this;
      return {
        AfterChangeMapLayerStyleEvent: function AfterChangeMapLayerStyleEvent(event) {
          return _this._updateLayerStyle(event.getMapLayer());
        },
        AfterChangeMapLayerOpacityEvent: function AfterChangeMapLayerOpacityEvent(event) {
          return _this._updateLayerOpacity(event.getMapLayer());
        },
        MapLayerVisibilityChangedEvent: function MapLayerVisibilityChangedEvent(event) {
          return _this._updateLayerStyle(event.getMapLayer());
        },
        WFSFeaturesSelectedEvent: function WFSFeaturesSelectedEvent(event) {
          return _this._updateSelection(event.getMapLayer(), event.getWfsFeatureIds());
        }
      };
    }

    /**
     * @method getLayerStyleFunction
     * Returns OL style corresponding to the layer's selected style
     * @param {Oskari.mapframework.bundle.mapwfs2.domain.WFSLayer} layer
     * @param {function} styleFunction
     * @param {[number|string]} selectedIds
     * @return {function} style function for the layer
     */
  }, {
    key: "getStyleFunction",
    value: function getStyleFunction(layer, styleFunction, selectedIds) {
      this._log.debug('TODO: getStyleFunction() not implemented on LayerHandler');
    }

    /**
     * @method refreshLayer forces feature update on layer
     * @param {Oskari.mapframework.bundle.mapwfs2.domain.WFSLayer} layer
     */
  }, {
    key: "refreshLayer",
    value: function refreshLayer(layer) {
      this._log.debug('TODO: refreshLayer() not implemented on LayerHandler');
    }
  }, {
    key: "getFeaturesWithFilter",
    value: function getFeaturesWithFilter(layerId) {
      var geojson = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var features = this._getFeaturesInViewport(layerId);
      if (!features.length) {
        return [];
      }
      var geojsonFeatures = features.map(function (feat) {
        return getFeatureAsGeojson(feat);
      });
      if (geojson && geojson.geometry) {
        geojsonFeatures = filterFeaturesByGeometry(geojsonFeatures, geojson.geometry);
      }
      if (geojson && geojson.properties) {
        geojsonFeatures = filterFeaturesByAttribute(geojsonFeatures, geojson.properties);
      }
      return geojsonFeatures;
    }
  }, {
    key: "_getFeaturesInViewport",
    value: function _getFeaturesInViewport(layerId) {
      var source = this._getLayerSource(layerId);
      if (!source) {
        return [];
      }
      var _this$plugin$getSandb = this.plugin.getSandbox().getMap().getBbox(),
        left = _this$plugin$getSandb.left,
        bottom = _this$plugin$getSandb.bottom,
        right = _this$plugin$getSandb.right,
        top = _this$plugin$getSandb.top;
      var extent = [left, bottom, right, top];
      return source.getFeaturesInExtent(extent) || [];
    }

    /**
     * Returns source corresponding to given layer
     * @param {Oskari.mapframework.bundle.mapwfs2.domain.WFSLayer} layer or layerId
     * @return {ol/source/VectorTile}
     */
  }, {
    key: "_getLayerSource",
    value: function _getLayerSource(layer) {
      var olLayers = this.plugin.getOLMapLayers(layer) || [];
      var mainLayer = olLayers.length ? olLayers[0] : null;
      if (!mainLayer) {
        return;
      }
      var source = mainLayer.getSource();
      if (source instanceof olCluster) {
        // Get wrapped vector source
        source = source.getSource();
      }
      return source;
    }

    /**
     * @private @method _updateLayerStyle
     * @param {Oskari.mapframework.bundle.mapwfs2.domain.WFSLayer} layer
     */
  }, {
    key: "_updateLayerStyle",
    value: function _updateLayerStyle(layer) {
      if (!this.layerIds.includes(layer.getId())) {
        return;
      }
      this.plugin.updateLayerStyle(layer);
      this.selectionHelper.updateSelectionStyles(layer);
    }
  }, {
    key: "_updateSelection",
    value: function _updateSelection(layer, featureIds) {
      if (!this.layerIds.includes(layer.getId())) {
        return;
      }
      this.selectionHelper.updateSelection(layer, featureIds);
    }

    /**
     * @private @method _updateLayerOpacity
     * @param {Oskari.mapframework.bundle.mapwfs2.domain.WFSLayer} layer
     */
  }, {
    key: "_updateLayerOpacity",
    value: function _updateLayerOpacity(layer) {
      if (!this.layerIds.includes(layer.getId())) {
        return;
      }
      var olLayers = this.plugin.getOLMapLayers(layer);
      if (!olLayers || olLayers.length === 0) {
        return;
      }
      olLayers[0].setOpacity(layer.getOpacity() / 100);
    }
  }, {
    key: "applyZoomBounds",
    value: function applyZoomBounds(layerDef, layerImpl) {
      var mapModule = this.plugin.getMapModule();
      var zoomLevelHelper = getZoomLevelHelper(mapModule.getScaleArray());
      zoomLevelHelper.setOLZoomLimits(layerImpl, layerDef.getMinScale(), layerDef.getMaxScale());
    }
  }, {
    key: "sendWFSStatusChangedEvent",
    value: function sendWFSStatusChangedEvent(layerId, status) {
      var loadEvent = Oskari.eventBuilder('WFSStatusChangedEvent')(layerId);
      loadEvent.setRequestType(loadEvent.type.image);
      this._setLoadingStatusToEvent(loadEvent, status);
      this.sb.notifyAll(loadEvent);
    }
  }, {
    key: "_setLoadingStatusToEvent",
    value: function _setLoadingStatusToEvent(loadEvent, status) {
      switch (status) {
        case LOADING_STATUS_VALUE.LOADING:
          loadEvent.setStatus(loadEvent.status.loading);
          break;
        case LOADING_STATUS_VALUE.COMPLETE:
          loadEvent.setStatus(loadEvent.status.complete);
          break;
        case LOADING_STATUS_VALUE.ERROR:
          loadEvent.setStatus(loadEvent.status.error);
          break;
        default:
          Oskari.log(this.getName()).error('Unsupported status: ' + status);
      }
    }

    /**
     * @method tileLoadingStateChanged
     * @param layerId
     * @param {RequestCounter} counter
     */
  }, {
    key: "tileLoadingStateChanged",
    value: function tileLoadingStateChanged(layerId, counter) {
      if (counter.getLastStatusUpdate() === LOADING_STATUS_VALUE.LOADING) {
        this.plugin.getMapModule().loadingState(layerId, true);
        if (counter.isFirstPending()) {
          this.sendWFSStatusChangedEvent(layerId, LOADING_STATUS_VALUE.LOADING);
          this._setTimer(layerId, counter);
        }
        return;
      }
      if (counter.getLastStatusUpdate() === LOADING_STATUS_VALUE.ERROR) {
        this.plugin.getMapModule().loadingState(layerId, null, true);
      } else if (counter.getLastStatusUpdate() === LOADING_STATUS_VALUE.COMPLETE) {
        this.plugin.getMapModule().loadingState(layerId, false);
      }
      var loadingStatus = counter.getFinishedStatus();
      if (!loadingStatus) {
        return;
      }
      this._resetTimer(layerId);
      this.sendWFSStatusChangedEvent(layerId, loadingStatus);
      counter.reset();
    }
  }, {
    key: "_setTimer",
    value: function _setTimer(layerId, counter) {
      var _this2 = this;
      this._resetTimer(layerId);
      this.loadingTimers.set(layerId, setTimeout(function () {
        if (counter.isPending()) {
          _this2.sendWFSStatusChangedEvent(layerId, LOADING_STATUS_VALUE.ERROR);
          counter.reset();
        }
      }, this.timerDelayInMillis));
    }
  }, {
    key: "_resetTimer",
    value: function _resetTimer(layerId) {
      if (this.loadingTimers.get(layerId)) {
        clearTimeout(this.loadingTimers.get(layerId));
      }
    }
  }]);
}();